import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import { rootReducer } from "@/shared/store";
import { ENV } from "./appConfig";

declare global {
  interface Window {
    rpState?: () => unknown;
  }
}

const persistConfig = { key: "root", storage, blacklist: ["toastr"] };
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: (ENV as any).DISABLE_REDUX_DEVTOOLS !== "true",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
          "@ReduxToastr/confirm/SHOW",
        ],
        ignoredPaths: ["toastr.confirm"],
      },
    }),
});

export const persistor = persistStore(store);

if (import.meta.env.DEV) {
  window.rpState = () => store.getState();
}

export default store;
